<script setup>
import { computed } from 'vue'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
  selectPlaceholder: {
    type: String,
    default: '-- Оберіть значення --',
  },
  searchPlaceholder: {
    type: String,
    default: 'Пошук за назвою або ID',
  },
  noResultsText: {
    type: String,
    default: 'Нічого не знайдено',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])
const normalizedOptions = computed(() =>
  Array.from(
    props.options.reduce((map, item) => {
      const id = String(item?.id ?? '')
      if (!id || map.has(id)) return map

      map.set(id, {
        id,
        label: String(item?.label ?? id),
      })

      return map
    }, new Map()).values(),
  ),
)

const selectedValue = computed({
  get() {
    if (props.modelValue === null || props.modelValue === undefined || props.modelValue === '') {
      return null
    }

    return String(props.modelValue)
  },
  set(value) {
    emit('update:modelValue', value === null || value === undefined ? '' : String(value))
  },
})

const optionsWithSelected = computed(() => {
  const currentValue = selectedValue.value
  if (!currentValue) return normalizedOptions.value
  if (normalizedOptions.value.some((item) => item.id === currentValue)) return normalizedOptions.value

  return [{ id: currentValue, label: currentValue }, ...normalizedOptions.value]
})

const placeholderText = computed(() => props.searchPlaceholder || props.selectPlaceholder)

function filterBy(option, label, search) {
  const query = String(search || '').trim().toLowerCase()
  if (!query) return true

  const optionLabel = String(label || '').toLowerCase()
  const optionId = String(option?.id ?? '').toLowerCase()
  return optionLabel.includes(query) || optionId.includes(query)
}

const reduceValue = (option) => String(option?.id ?? '')
</script>

<template>
  <VueSelect
    v-model="selectedValue"
    :options="optionsWithSelected"
    :reduce="reduceValue"
    label="label"
    :placeholder="placeholderText"
    :filter-by="filterBy"
    :clearable="true"
    :searchable="true"
    :disabled="disabled"
  >
    <template #no-options>
      {{ noResultsText }}
    </template>
  </VueSelect>
</template>

<style scoped>
:deep(.vs__dropdown-toggle) {
  min-height: 38px;
}

:deep(.vs__search) {
  margin-top: 0;
}
</style>
